import AOS from 'aos';
import 'aos/dist/aos.css';

let animScroll = {
    init() {

        AOS.init({
            easing: 'ease-out-back',
            duration: 1000
        });
    }
}

export default animScroll;
